<template>
  <div class="page-wrapper" v-if="stockDetailData">

    <h3>基础信息</h3>
    <Row>
      <Col span="6">房间号：<span class="info">{{stockDetailData.houseNumber || ''}}</span></Col>
      <Col span="6">项目名称：<span class="info">{{stockDetailData.projectName || ''}}</span></Col>
      <Col span="6">业主名称：<span class="info">{{stockDetailData.ownerName || ''}}</span></Col>
      <Col span="6">楼栋：<span class="info">{{stockDetailData.buildingName || ''}}</span></Col>
      <Col span="6">楼层：<span class="info">{{stockDetailData.houseFloorNumber || ''}}</span></Col>
      <Col span="6">面积：<span class="info">{{stockDetailData.houseArea || ''}}</span></Col>
      <Col span="6">朝向：<span class="info">{{getDirStr(stockDetailData.houseDirection) || ''}}</span></Col>

      <Col span="6">房型：<span class="info">{{stockDetailData.houseTypeName || ''}}</span></Col>
      <Col span="6">户型：<span class="info">{{`${stockDetailData.houseTypeRooms}室${stockDetailData.houseTypeHall}厅${stockDetailData.houseTypeBathroom}卫`}}</span></Col>
      <Col span="6">装修风格：<span class="info">{{stockDetailData.houseDecorationstyleVO || ''}}</span></Col>
      <Col span="6">床类型：<span class="info">{{stockDetailData.houseBedTypeVO || ''}}</span></Col>
      <Col span="6">价格：<span class="info">{{stockDetailData.houseRentPrice || ''}}</span></Col>
      <Col span="6" v-if="stockDetailData.houseRentType===1">性别限制：<span class="info">{{stockDetailData.limitLabelStr || ''}}</span></Col>
    </Row>

    <h3>运营信息</h3>
    <Row>
      <Col span="6">出租类型：<span class="info">{{stockDetailData.houseRentTypeVO || ''}}</span></Col>
      <Col span="6">房间状态：<span class="info">{{stockDetailData.houseStatusVO || ''}}</span></Col>
      <Col span="6">空置天数：<span class="info">{{stockDetailData.houseVacancyDay || ''}}</span></Col>
      <Col span="6">发送签约邀请次数：<span class="info">{{stockDetailData.houseSignInviteNum}}</span></Col>
      <Col span="6">可出租时间：<span class="info">{{ stockDetailData.houseRentdate ? formatDate(stockDetailData.houseRentdate) : ''}}</span></Col>
      <Col span="6">出租截止日：<span class="info">{{stockDetailData.houseMaxSignDate ? formatDate(stockDetailData.houseMaxSignDate) : ''}}</span></Col>
      <Col span="6">备注：<span class="info">{{stockDetailData.remark || ''}}</span></Col>
    </Row>

  </div>
</template>

<script type="text/ecmascript-6">

import { getHouseDetail } from "api/outHouse"
import { formatDateTime } from '@/utils/format'
export default {
  name:'housedetail',
  props:{

  },
  created(){
    if(this.$route.params.stockFid){
      this.getDetail(this.$route.params.stockFid)
    }
  },
  activated(){
    if(this.$route.params.stockFid){
      this.getDetail(this.$route.params.stockFid)
    }
  },
  data () {
    return {
      stockFid:'',
      // stockDetailData:null
      stockDetailData:{}
    };
  },
  methods:{
    getDetail(stockFid){
      // console.log(this.$route.params.stockFid)
      getHouseDetail(stockFid).then( res => {
        this.stockDetailData = res.data
      })
    },
    formatDate(date){
      return formatDateTime(date,false)
    },
    getDirStr(dirCode) {
    let str = ''
    switch(dirCode) {
      case 1:
        str='东'
        break;
      case 2:
        str='南'
        break;
      case 3:
        str='西'
        break;
      case 4:
        str='北'
        break;
      case 5:
        str='人造天井'
        break;
      case 6:
        str='西南'
        break;
      case 7:
        str='东南'
        break;
      case 8:
        str='东北'
        break;
      case 9:
        str='西北'
        break;
      default:
        str='其他'
    }
    return str
  }
  }
}
</script>

<style lang="css" scoped>
h3 {
  margin: 16px 0 8px;
}
p {
  line-height: 2.5;
}
.info {
  padding-left: 8px;
  font-weight: 600;
}
.ivu-col-span-6 {
  min-width: 220px;
}
.ivu-row, p {
  line-height: 3;
}

 p span:first-child {
   padding-left: 0;
 }
 p span:last-child {
   border-right-width:0px;
 }
</style>
